import { gqlClient } from "@/utils/graphql-client";

export function fetcher<TData, TVariables>(
  query: string,
  variables?: TVariables,
  headers?: HeadersInit
) {
  return () => gqlClient.request<TData>(query, variables, headers as Record<string, string>);
}
